import { observer } from 'mobx-react';
import { PersonaSize } from 'office-ui-fabric-react/lib/Persona';
import PersonaControl from 'owa-persona/lib/components/PersonaControl';
import * as React from 'react';

const styles = require('./PersonaDetailView.scss');

export interface PersonaDetailViewProps {
    organizerName: string;
    organizerEmail: string;
}

export const PersonaDetailView = observer(function PersonaDetailView(
    props: PersonaDetailViewProps
) {
    const { organizerName, organizerEmail } = props;
    return (
        <div className={styles.personContainer}>
            <div className={styles.personaControlContainer}>
                <PersonaControl
                    name={organizerName}
                    emailAddress={organizerEmail}
                    size={PersonaSize.extraExtraSmall}
                />
            </div>
            <div className={styles.personaName}> {organizerName} </div>
        </div>
    );
});
